export const normalizeNumberField = value => {
  const matched = `${value}`.match(/(\d)+(\.|,)?(\d){0,}/);
  return matched ? matched[0].replace(/,/, '.') : '';
};

export const getAllCargosDevices = (formData = []) => {
  if (!formData.length) return formData;

  const data = formData.reduce((acc, curr) => {
    const cargoDevices = curr.devices;
    if (cargoDevices) {
      acc.push(...cargoDevices);
    }

    return acc;
  }, []);

  return data;
};
